import axios, { AxiosRequestConfig } from "axios"
import store from "../src/store/index"
import router from "../src/router"

const timeout = 30000
const clientId = process.env.VUE_APP_OAUTH_CLIENT_ID
const clientSecret = process.env.VUE_APP_OAUTH_CLIENT_SECRET

import UUIDGenerator from "../utils/UUIDGenerator"
const uuid = UUIDGenerator.generate()


const client = axios.create({
  baseURL: `//${process.env.VUE_APP_API_HOST}/api/`,
  timeout,
  headers: {
		"Content-Type": "application/json",
    "X-Device-UUID": uuid,
    "X-App-Version": "6.4.3",
    "X-OS-Version": "10.14",
    "X-OS": "ios",
    "Accept": "application/json, version=1",
  }
})

// To manage 401 errors !
client.interceptors.response.use( (response) => {
  return response
}, (error) => {
  if (error.response.status === 401) {
    store.dispatch('destroySession')
    router.push({ name: "login" })
    return Promise.reject(error)
  } else {
    return Promise.reject(error)
  }
})

const init = async () => {
  try {
    const response = await client.post("/token", {
      grant_type: "client_credentials",
      client_id: clientId,
      client_secret: clientSecret,
    }, {
        baseURL: `//${process.env.VUE_APP_API_HOST}/api/oauth`
      })
    // tslint:disable-next-line:no-string-literal
    client.defaults.headers["Authorization"] = `Bearer ${response.data.access_token}`
  } catch (err) {
    console.log("init error", err)
    throw err
  }
}

const setToken = () => {
  client.defaults.headers["Authorization"] = `Bearer ${store.state.token}`
}

export default {
  client,
  init,
  setToken,
  get(url: string, config?: AxiosRequestConfig) {
    return client.get(url, config)
  },
  post(url: string, params?: object, config?: AxiosRequestConfig) {
    return client.post(url, params, config)
  },
  put(url: string, params: object, config?: AxiosRequestConfig) {
    return client.put(url, params, config)
  },
  delete(url: string, config?: AxiosRequestConfig) {
    return client.delete(url, config)
  },
}
